import Action from 'actions';
import {PositionInLineup} from 'helpers/lineup-helper';
import Const from 'constants';
import BaseLineup from 'services/sports/default/base-lineup';

export default class LineupClassic extends BaseLineup {
    // setPlayersByColumns({incomingValues: {team, lineupId}}) {
    //     const {sportConfig} = Action.getState();
    //     const positionsOrder = sportConfig.getConfigProp('positionsOrder', {});

    //     const params = {
    //         team,
    //         positionsOrder,
    //         functions: this.exec('getFunctionsToSetPlayersByColumns', {lineupId}, {}),
    //     };

    //     let players = PositionInLineup.set.inDependenceOnOrder(params);

    //     if (!sportConfig.isModeLateswap()) {
    //         players = this.exec('forcePlayerToFlexPosition', {
    //             lineupPlayers: players,
    //             flexPositionNames: [Const.NBA_DK_POSITION_G, Const.NBA_DK_POSITION_F, Const.POSITION_UTIL],
    //             getSubstitutablePositionNames: (player) => player.positionShortNames,
    //             isPlayerSubstitutable: function (toPlayer, fromPlayer, game) {
    //                 return game.teams.includes(toPlayer.team)
    //                     && fromPlayer.positionShortNames.includes(toPlayer.positionName)
    //                     && toPlayer.positionShortNames.includes(fromPlayer.positionName);
    //             },
    //             groupPlayersByPosition: function (players) {
    //                 const result = {};
    //                 players.map((player) => {
    //                     player.positionShortNames.map((positionName) => {
    //                         result[positionName] ??= [];
    //                         result[positionName].push(player);
    //                     });
    //                 });

    //                 return result;
    //             },
    //         });
    //         players = this.exec('forcePlayerToFlexPosition', {
    //             lineupPlayers: players,
    //             flexPositionNames: [Const.NBA_DK_POSITION_G, Const.NBA_DK_POSITION_F, Const.POSITION_UTIL],
    //             getSubstitutablePositionNames: (player) => player.positionShortNames,
    //             isPlayerSubstitutable: function (toPlayer, fromPlayer, game) {
    //                 return game.teams.includes(toPlayer.team)
    //                     && fromPlayer.positionShortNames.includes(toPlayer.positionName)
    //                     && toPlayer.positionShortNames.includes(fromPlayer.positionName);
    //             },
    //             groupPlayersByPosition: function (players) {
    //                 const result = {};
    //                 players.map((player) => {
    //                     player.positionShortNames.map((positionName) => {
    //                         result[positionName] ??= [];
    //                         result[positionName].push(player);
    //                     });
    //                 });

    //                 return result;
    //             },
    //         });
    //         players = this.exec('forcePlayerToFlexPosition', {
    //             lineupPlayers: players,
    //             flexPositionNames: [Const.POSITION_UTIL],
    //             isPlayerSubstitutable: function (toPlayer, fromPlayer, game) {
    //                 return game.teams.includes(toPlayer.team)
    //                     && [Const.NBA_DK_POSITION_G, Const.NBA_DK_POSITION_F].includes(toPlayer.positionInLineup);
    //             },
    //             getSubstitutablePositionNames: function (player) {
    //                 const map = {
    //                     PG: ['SG', 'PG'],
    //                     SG: ['SG', 'PG'],
    //                     PF: ['SF', 'PF'],
    //                     SF: ['SF', 'PF'],
    //                 };

    //                 return map[player.positionName] || [player.positionName];
    //             },
    //         });
    //         players = this.exec('forcePlayerToFlexPosition', {
    //             lineupPlayers: players,
    //             flexPositionNames: [Const.POSITION_UTIL],
    //             isPlayerSubstitutable: function (toPlayer, fromPlayer, game) {
    //                 return game.teams.includes(toPlayer.team)
    //                     && [Const.NBA_DK_POSITION_G, Const.NBA_DK_POSITION_F].includes(toPlayer.positionInLineup);
    //             },
    //             getSubstitutablePositionNames: function (player) {
    //                 const map = {
    //                     PG: ['SG', 'PG'],
    //                     SG: ['SG', 'PG'],
    //                     PF: ['SF', 'PF'],
    //                     SF: ['SF', 'PF'],
    //                 };

    //                 return map[player.positionName] || [player.positionName];
    //             },
    //         });
    //     }

    //     return [...players];
    // }

    setPlayersByColumns({incomingValues: {team, lineupId}}) {
        const {sportConfig} = Action.getState();
        const positionsOrder = sportConfig.getConfigProp('positionsOrder', {});

        const params = {
            team,
            positionsOrder,
            functions: this.exec('getFunctionsToSetPlayersByColumns', {lineupId}, {}),
        };

        let players = PositionInLineup.set.inDependenceOnOrder(params);

        if (sportConfig.isModeLateswap()) {
            return [...players];
        }

        const groupPlayersByPosition = (players) => {
            const result = {};
            players.map((player) => player.positionShortNames.map((positionName) => {
                result[positionName] ??= [];
                result[positionName].push(player);
            }));

            return result;
        };

        const changePositionIfNeeded = (player) => {
            let positionName = player.positionName;

            if (inArray(player.positionInLineup, ['C', 'PF', 'PG', 'SF', 'SG'])) {
                positionName = player.positionInLineup;
            } else if (inArray(player.positionInLineup, ['F', 'G'])) {
                const map = {
                    F: ['PF', 'SF'],
                    G: ['PG', 'SG'],
                };

                [positionName = player.positionName] = arrayDuplicates(player.positionShortNames, map[player.positionInLineup]);
            }

            player.position = sportConfig.getPositionNumberByName(positionName);
            player.positionName = positionName;
        };

        for (let i = 0; i < 2; i++) {
            players = this.exec('forcePlayerToFlexPosition', {
                lineupPlayers: players,
                flexPositionNames: [Const.POSITION_UTIL],
                getSubstitutablePositionNames: (fromPlayer) => fromPlayer.positionShortNames,
                isPlayerSubstitutable: (toPlayer, fromPlayer, gamesIndexedByTeamName) => {
                    const toPlayerGame = gamesIndexedByTeamName[toPlayer.team];
                    const fromPlayerGame = gamesIndexedByTeamName[fromPlayer.team];
                    const map = {
                        F: ['PF', 'SF'],
                        G: ['PG', 'SG'],
                    };

                    return arrayDuplicates(fromPlayer.positionShortNames, map[toPlayer.positionInLineup] ?? [toPlayer.positionInLineup]).length
                        && (toPlayerGame.gameTimestamp > fromPlayerGame.gameTimestamp || toPlayer.salary > fromPlayer.salary);
                },
                groupPlayersByPosition,
                changePositionIfNeeded,
            });
        }

        for (let i = 0; i < 2; i++) {
            players = this.exec('forcePlayerToFlexPosition', {
                lineupPlayers: players,
                flexPositionNames: [Const.NBA_DK_POSITION_F, Const.NBA_DK_POSITION_G],
                getSubstitutablePositionNames: (fromPlayer) => fromPlayer.positionShortNames,
                isPlayerSubstitutable: (toPlayer, fromPlayer, gamesIndexedByTeamName) => {
                    const toPlayerGame = gamesIndexedByTeamName[toPlayer.team];
                    const fromPlayerGame = gamesIndexedByTeamName[fromPlayer.team];
                    const map = {
                        F: ['PF', 'SF'],
                        G: ['PG', 'SG'],
                    };

                    return fromPlayer.positionShortNames.includes(toPlayer.positionInLineup)
                        && arrayDuplicates(toPlayer.positionShortNames, map[fromPlayer.positionInLineup]).length
                        && (toPlayerGame.gameTimestamp > fromPlayerGame.gameTimestamp || toPlayer.salary > fromPlayer.salary);
                },
                groupPlayersByPosition,
                changePositionIfNeeded,
            });
        }

        return [...players];
    }
}
